import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/home.vue'
import ConstructionTable from '@/views/ConstructionTable.vue'

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/construction',
    name: 'ConstructionTable',
    component: ConstructionTable
  }
  // 其他路由配置
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router